import React from "react";
import { motion } from "framer-motion";
import { Calendar, MapPin, ArrowUpRight } from "lucide-react";
import { UPDATES, fadeUp } from "../../data";

export const Updates = () => {
  return (
    <section id="updates" className="relative py-24 md:py-32" style={{ background: "var(--softblue)" }}>
      <div className="container-x">
        <motion.div variants={fadeUp} initial="hidden" whileInView="show" viewport={{ once: true }} className="mb-14 max-w-2xl">
          <span className="eyebrow" style={{ color: "var(--blue)" }}>Latest Updates</span>
          <h2 className="font-display font-bold tracking-tight text-3xl md:text-4xl lg:text-5xl mt-4" style={{ color: "var(--navy)" }}>
            Out and about, meeting people.
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-6 gap-6">
          {UPDATES.map((u, i) => {
            const featured = i === 0;
            return (
              <motion.article key={i} variants={fadeUp} custom={i} initial="hidden" whileInView="show" viewport={{ once: true }}
                data-testid={`update-card-${i}`}
                className={`group bg-white rounded-2xl overflow-hidden border hover:-translate-y-1.5 hover:shadow-[0_18px_40px_rgba(25,118,210,0.12)] transition-all duration-300 shadow-[0_8px_30px_rgba(0,0,0,0.04)] ${
                  featured ? "md:col-span-6 lg:col-span-6" : "md:col-span-3 lg:col-span-2"
                }`}
                style={{ borderColor: "var(--grey)" }}>
                <div className={`p-7 md:p-8 ${featured ? "md:flex md:items-center md:gap-10" : ""}`}>
                  <div className={featured ? "md:flex-1" : ""}>
                    <div className="flex items-center gap-3 flex-wrap">
                      <span className="font-body text-[11px] font-semibold tracking-wider uppercase px-3 py-1 rounded-full"
                        style={{ background: "rgba(25,118,210,0.10)", color: "var(--blue)" }}>{u.cat}</span>
                    </div>
                    <h3 className={`font-display font-semibold mt-4 ${featured ? "text-2xl md:text-3xl" : "text-lg"}`}
                      style={{ color: "var(--navy)" }}>{u.title}</h3>
                    <div className="flex items-center gap-4 mt-3 font-body text-xs" style={{ color: "var(--muted)" }}>
                      <span className="inline-flex items-center gap-1.5"><Calendar size={13} /> {u.date}</span>
                      <span className="inline-flex items-center gap-1.5"><MapPin size={13} /> {u.loc}</span>
                    </div>
                    <p className={`font-body leading-relaxed mt-4 ${featured ? "text-base max-w-2xl" : "text-sm"}`} style={{ color: "var(--text2)" }}>{u.body}</p>
                    {u.quote && (
                      <p className="font-display italic text-lg mt-5 pl-4 border-l-2" style={{ color: "var(--navy)", borderColor: "var(--gold)" }}>
                        “{u.quote}”
                      </p>
                    )}
                    <button className="inline-flex items-center gap-1.5 mt-5 font-body text-sm font-semibold group/btn" style={{ color: "var(--blue)" }}>
                      Learn More <ArrowUpRight size={16} className="group-hover/btn:translate-x-0.5 group-hover/btn:-translate-y-0.5 transition-transform" />
                    </button>
                  </div>
                </div>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
};
